import { combineReducers } from 'redux';
import institutionReducer from './institution/institutionReducer';

const rootReducer = combineReducers({
    institution: institutionReducer
});

export default rootReducer;